import { Theme, ThemeUICSSObject } from 'theme-ui';
import { modals } from './modals';
import { tables } from './tables';
import { forms } from './forms';
import { trees } from './trees';
import { tooltips } from './tooltips';
import { components } from './components';
import { boxes } from './boxes';
import { chat } from './chat';
import { newChat } from './newChat';
/* IMPORT HERE */
export const common: (theme: Theme) => ThemeUICSSObject = (theme) => {
  return {
    boxes,
    chat,
    forms,
    modals,
    tables: tables(theme),
    components: components,
    trees,
    tooltips,
    newChat,
    /* PREPEND HERE */
  };
};
